import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Text } from "grommet";
import * as React from "react";
import { MatchOutcomeViewModel } from "./MatchesStore";

const trophyStar = (color) => <FontAwesomeIcon icon={["fad", "trophy-star"]} color={color}></FontAwesomeIcon>;
const handshake = (color) => <FontAwesomeIcon icon={["fad", "handshake"]} color={color}></FontAwesomeIcon>;
const ban = (color) => <FontAwesomeIcon icon={["fad", "ban"]} color={color}></FontAwesomeIcon>;
const x = (color) => <FontAwesomeIcon icon={["fad", "x"]} color={color}></FontAwesomeIcon>;
const skullCross = (color) => <FontAwesomeIcon icon={["fad", "skull-crossbones"]} color={color}></FontAwesomeIcon>;
const dash = (color) => <FontAwesomeIcon icon={["fad", "dash"]} color={color}></FontAwesomeIcon>;

export function OutcomeIcon(outcome) {
    if (!outcome) return dash(OutcomeColor(outcome));
    switch (outcome.outcomeType) {
        case "None":
            return dash(OutcomeColor(outcome));
        case "Win":
            return trophyStar(OutcomeColor(outcome));
        case "Loss":
            return skullCross(OutcomeColor(outcome));
        case "Draw":
            return handshake(OutcomeColor(outcome));
        case "Forfeit":
            return x(OutcomeColor(outcome));
        case "Disqualify":
            return ban(OutcomeColor(outcome));
    }
}

export function OutcomeColor(outcome) {
    if (!outcome) return "";
    switch (outcome.outcomeType) {
        case "None":
            return "#ffffff";
        case "Win":
            return "#00C781";
        case "Loss":
            return "#FFAA15";
        case "Draw":
            return "#00739D";
        case "Forfeit":
            return "#FF4040";
        case "Disqualify":
            return "#FF4040";
    }
}

export const Outcome = ({ outcome, disabled, includeText, onClick }: { outcome: MatchOutcomeViewModel; disabled: boolean; includeText?: boolean; onClick?: Function }) => {
    let icon = OutcomeIcon(outcome);

    let BoxProps = !disabled && onClick ? { hoverIndicator: "background-back", onClick: () => onClick && onClick() } : {};
    return (
        <Box direction={"row"} background={"background-front"} pad="small" gap="small" round="10px" title={outcome.outcomeType} {...BoxProps} align="center">
            {icon}
            {includeText && <Text>{outcome.outcomeType}</Text>}
        </Box>
    );
};
